export default "__VITE_ASSET__BKyfvotj__"